import React from 'react';
import Shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/local';
import { ROUTE } from 'constant';
import { withRouter } from 'react-router-dom';
import { createLink } from 'utils';
import CreateForm from './create';

export default withRouter(({
  history = {}, dcId, nlbId, nlbProperties, items = [],
}) => (
  <Shared.widgets.Section
    sectionTitle="Forwarding Rules"
    itemIcon="angle-double-right"
    className="-m-t-24"
    items={items}
    setItemTitle={(e) => e?.properties?.name}
    setItemDetails={(e) => (
      <Shared.utilities.DetailsLine object={{ IP: e?.properties?.listenerIp, Port: e?.properties?.listenerPort, Targets: e?.properties?.targets.length }} />
    )}
    itemOnClick={(e) => history.push(createLink(ROUTE.DASHBOARD.NLB_FORWARDING_RULE, { dcId, nlbId, id: e?.id }))}
    createForm={<CreateForm nlbProperties={nlbProperties} {...{ dcId, nlbId }} />}
    createActionType={ACTIONS_TYPES.NETWORK_LOAD_BALANCER.CREATE_FORWARDING_RULE}
  />
));
